import { Flex, Skeleton, Wrapper } from 'ui';

const ChatDetailHeaderSkeleton = () => (
  <Wrapper paddingHorizontal="sm" paddingVertical="xxs">
    <Flex align="center" gap="xs">
      <Skeleton.Avatar active size={40} />
      <Flex flex={1}>
        <Skeleton active paragraph={{ rows: 2, width: ['50%', '30%'] }} title={false} />
      </Flex>
    </Flex>
  </Wrapper>
);

export default ChatDetailHeaderSkeleton;
